import { __, _x } from "@wordpress/i18n";
import { useCallback, useEffect, useRef, useState } from "@wordpress/element";

import { useMapsLibrary } from "@vis.gl/react-google-maps";

export function PlaceAutocomplete({
  value,
  onChange,
  placeholder,
  options = {},
  ...props
}) {
  const [placeAutocomplete, setPlaceAutocomplete] = useState(null);

  const inputRef = useRef(null);
  const places = useMapsLibrary("places");

  useEffect(
    function () {
      if (!places || !inputRef.current) return;

      const allOptions = {
        fields: ["geometry", "name"],
        ...options,
      };

      const autocompleteApi = new places.Autocomplete(
        inputRef.current,
        allOptions
      );
      setPlaceAutocomplete(autocompleteApi);
    },
    [places]
  );

  useEffect(
    function () {
      if (!placeAutocomplete) return;

      placeAutocomplete.addListener("place_changed", () => {
        try {
          const place = placeAutocomplete.getPlace();
          onChange(place);
        } catch (error) {
          console.error("Place autocomplete failed:", error);
        }
      });
    },
    [onChange, placeAutocomplete]
  );

  useEffect(
    function () {
      if (!inputRef.current || !value) return;
      inputRef.current.value = value;
    },
    [value]
  );

  const selectFirstPlace = useCallback(
    async function () {
      if (!places || !inputRef.current) return;

      const value = inputRef.current.value;
      if (!value) return;

      try {
        const request = {
          textQuery: value,
          fields: ["displayName", "location"],
          region:
            options &&
            options.componentRestrictions &&
            options.componentRestrictions.country
              ? typeof options.componentRestrictions.country === "string"
                ? options.componentRestrictions.country
                : options.componentRestrictions.country[0]
              : null,
        };
        const { places: results } = await places.Place.searchByText(request);

        if (!results || !results.length) return;
        const firstResult = results[0];
        inputRef.current.value = firstResult.displayName;
        onChange(firstResult);
      } catch (error) {
        console.error("Place search failed:", error);
      }
    },
    [places, inputRef.current]
  );

  return (
    <span className="place-autocomplete">
      <input
        className="place-autocomplete-input"
        type="text"
        ref={inputRef}
        placeholder={placeholder}
        {...props}
      />
      <button className="place-autocomplete-button" onClick={selectFirstPlace}>
        {_x("Trouver", "Frontend stores map", "manitoba-stores")}
      </button>
    </span>
  );
}
